"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var debug_1 = __importDefault(require("debug"));
var debug = debug_1.default('https-proxy-agent:parse-proxy-response');
function parseProxyResponse(socket) {
  return new Promise(function (resolve, reject) {
    // we need to buffer any HTTP traffic that happens with the proxy before we get
    // the CONNECT response, so that if the response is anything other than an "200"
    // response code, then we can re-play the "data" events on the socket once the
    // HTTP parser is hooked up...
    var buffersLength = 0;
    var buffers = [];
    function read() {
      var b = socket.read();
      if (b) ondata(b);else socket.once('readable', read);
    }
    function cleanup() {
      socket.removeListener('end', onend);
      socket.removeListener('error', onerror);
      socket.removeListener('close', onclose);
      socket.removeListener('readable', read);
    }
    function onclose(err) {
      debug('onclose had error %o', err);
    }
    function onend() {
      debug('onend');
    }
    function onerror(err) {
      cleanup();
      debug('onerror %o', err);
      reject(err);
    }
    function ondata(b) {
      buffers.push(b);
      buffersLength += b.length;
      var buffered = Buffer.concat(buffers, buffersLength);
      var endOfHeaders = buffered.indexOf('\r\n\r\n');
      if (endOfHeaders === -1) {
        // keep buffering
        debug('have not received end of HTTP headers yet...');
        read();
        return;
      }
      var firstLine = buffered.toString('ascii', 0, buffered.indexOf('\r\n'));
      var statusCode = +firstLine.split(' ')[1];
      debug('got proxy server response: %o', firstLine);
      resolve({
        statusCode: statusCode,
        buffered: buffered
      });
    }
    socket.on('error', onerror);
    socket.on('close', onclose);
    socket.on('end', onend);
    read();
  });
}
exports.default = parseProxyResponse;